import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getBusinessYears } from 'modules/accommodations/features/reservations/api';

export const useQueryBusinessYears = ({ id }: { id?: string }) => {
  return useQuery(QUERY_KEYS.INVOICES_BUSINESS_YEARS, () => getBusinessYears({ id }), {
    enabled: !!id,
  });
};
